import { Link } from "react-router-dom";
import "../styles/App.css";
import React from "react";
import Menu from "./Menu";

const Header = () => {
  const menuItems = [
    { label: "Home", href: "/" },
    { label: "Media", href: "/media" },
  ];

  return (
    <header className="bg-alice text-space border-b border-violet shadow-sm">
      <div className="w-full max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-playfair font-bold text-space">
          <Link
            to="/"
            className="hover:text-violet transition-colors duration-300"
          >
            Greg McMahon
          </Link>
        </h1>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {menuItems.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className="text-space/90 font-medium hover:text-violet transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu */}
        <div className="md:hidden">
          <Menu items={menuItems} />
        </div>
      </div>
    </header>
  );
};

export default Header;
